import { addDays } from 'date-fns';
import { makeEntityScaffold } from '@classpass/saga-tools';

import { transformV2ClientResponse } from 'helpers/core';
import URLS from 'constants/urls';

const handler = async ({ httpClient }, venueId) => {
  const today = new Date();
  const startDate = today;
  const endDate = addDays(today, 6);

  const upcomingSpotsEndpoint = URLS.home.upcomingSpots(venueId, startDate, endDate);
  const upcomingBookingsEndpoint = URLS.home.upcomingBookings(venueId, startDate, endDate);

  const responses = await Promise.all(
    [upcomingSpotsEndpoint, upcomingBookingsEndpoint].map(endpoint => httpClient.get(endpoint))
  );

  const [upcomingSpots, upcomingBookings] = responses.map(transformV2ClientResponse).map(({ data }) => data);

  return { upcomingSpots, upcomingBookings };
};

export default makeEntityScaffold('SAGA.API.UPCOMING_SPOTS_AND_BOOKINGS', handler, { defaultKey: 1 });
